package com.xtream.ui.tv.presentation.movies

import androidx.compose.foundation.focusGroup
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.BookmarkAdded
import androidx.compose.material.icons.outlined.BookmarkAdd
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.SheetValue
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.unit.dp
import androidx.lifecycle.Lifecycle
import androidx.lifecycle.compose.LifecycleEventEffect
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import coil3.compose.rememberAsyncImagePainter
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.add_to_favorites
import com.xtream.sharedResources.resources.may_like
import com.xtream.sharedResources.resources.remove_from_favorites
import com.xtream.composeapp.viewmodel.UserViewModel
import com.xtream.composeapp.viewmodel.VodInfoViewModel
import com.xtream.composeapp.viewmodel.VodStreamsViewModel
import com.xtream.data_kmp.XtreamUtils
import com.xtream.core_model.dto.MovieSubtitle
import com.xtream.data_kmp.dto.VodStream
import com.xtream.data_kmp.util.extension.formatTime
import com.xtream.ui.tv.presentation.common.TvBaseInfoLayout
import com.xtream.ui.tv.presentation.common.TvInfoComposeLayout
import com.xtream.ui.ui.widget.LazyContentRow
import com.xtream.ui.ui.widget.NetworkImageCard
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf


@Composable
fun TvMovieInfoComposeScreen(id: Int?,
                             onNavigationIconClick: () -> Unit={},
                             onMainButtonClick: (url:String?, title:String?, backdropPath: String?,     infos: List<String>?, progress: Long, subtitles: List<MovieSubtitle.Subtitle?>? ) -> Unit = { _, _, _, _, _, _->},
                             navKey: Screen.MovieDetail,

                             userInfViewModel: UserViewModel = koinViewModel(),
                             onRelatedItemClick: (VodStream?) -> Unit = {}
) {
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current
    val rootNavViewModel: RootNavViewModel = koinViewModel(
        viewModelStoreOwner= viewModelStoreOwner
    )



    val vodInfoViewModel: VodInfoViewModel = koinViewModel(  parameters = { parametersOf(navKey.id) })/*hiltViewModel<VodInfoViewModel, VodInfoViewModel.Factory>(
        creationCallback = { factory ->
            factory.create(navKey)
        }
    )*/
    val vodStreamsViewModel: VodStreamsViewModel =  koinViewModel( key="vodStream_${navKey::class.simpleName}${navKey.hashCode()}")
    /*hiltViewModel<VodStreamsViewModel, VodStreamsViewModel.Factory>(
        creationCallback = { factory ->
            factory.create(navKey)
        }
    )*/



    val streamState by vodInfoViewModel.streamState.collectAsStateWithLifecycle()
    val vodInfoState by remember(id){ vodInfoViewModel.vodInfoStateFlow }.collectAsStateWithLifecycle()
    val scope = rememberCoroutineScope()
    var trailerUrl by rememberSaveable(id) { mutableStateOf<String?>(null) }
    // Fetch stream asynchronously


    val isFavorite by remember(streamState) { vodStreamsViewModel.isFavoriteFlow(streamState) }.collectAsStateWithLifecycle(false)
    val items by vodInfoViewModel.recommendedItems.collectAsStateWithLifecycle()
    val subtitle by vodInfoViewModel.streamSubtitleState.collectAsStateWithLifecycle()
    val titleLogoState by vodInfoViewModel.streamTitleLogoState.collectAsStateWithLifecycle()

    var streamTitleLogo: String? by  rememberSaveable  { mutableStateOf(null) }
    val mainFocusRequester = remember { FocusRequester() }
    val firstItemFocusRequester = remember { FocusRequester() }

    var wasTopFocused by remember { mutableStateOf(true) }
    LifecycleEventEffect(Lifecycle.Event.ON_RESUME) {
        if (!wasTopFocused) {
            val canRestore = mainFocusRequester.restoreFocusedChild()
         }
    }
    LifecycleEventEffect(Lifecycle.Event.ON_PAUSE) {
         mainFocusRequester.saveFocusedChild()
        mainFocusRequester.freeFocus()
    }
    @OptIn(ExperimentalMaterial3Api::class)
    TvBaseInfoLayout(

        onSheetStateChange = {

            wasTopFocused = it == SheetValue.PartiallyExpanded
        },

        backDropPainter =  rememberAsyncImagePainter( vodInfoState?.info?.backdrop_path?.firstOrNull()),

        backLayerContent = {

            TvInfoComposeLayout(
                modifier = Modifier
                    .padding(horizontal = 48.dp)
                    .fillMaxSize()
                ,
                title = vodInfoState?.movie_data?.name,
                logoTitle = streamTitleLogo,
                rating = vodInfoState?.info?.formattedRating(),
                genre = vodInfoState?.info?.genre,
                plot = vodInfoState?.info?.plot,
                releaseDate = vodInfoState?.info?.releaseDate,
                duration = vodInfoState?.info?.duration?.formatTime(),
                onMainButtonClick = {
                    scope.launch {
                        val url = XtreamUtils.buildStreamUrl(
                            userInfViewModel.loggedInUser(),
                            streamState,
                            "." + streamState?.containerExtension,

                        )
                        val progress= vodStreamsViewModel.getWatched(vodInfoState?.movie_data?.stream_id)?.progress
                        onMainButtonClick.invoke(
                            url,
                            vodInfoState?.movie_data?.name,
                            vodInfoState?.info?.backdrop_path?.firstOrNull()
                                ?: streamState?.streamIcon,
                            listOf<String>(vodInfoState?.info?.genre?:"", vodInfoState?.info?.releaseDate?:""),
                            progress?:0L,
                            subtitle?.subtitles
                        )
                    }
                },
                secondaryButtonTitle = stringResource( if(isFavorite) Res.string.remove_from_favorites else Res.string.add_to_favorites),
                secondaryButtonIcon = if(isFavorite) Icons.Filled.BookmarkAdded else  Icons.Outlined.BookmarkAdd,
                onSecondaryButtonClick = {
                    vodStreamsViewModel.updateFavoriteStatus(streamState)
                },
                tertiaryButtonEnabled = !trailerUrl.isNullOrBlank(),
                tertiaryButtonClick = {
                    rootNavViewModel.navigate(Screen.Trailer(trailerUrl))
                },


                )
        },
        frontLayerContent = {
            LazyColumn(
                contentPadding = PaddingValues( vertical = 24.dp),

                ) {

                item{
                    LazyContentRow(
                        modifier = Modifier
                            .focusGroup()
                            .focusRequester(mainFocusRequester)
                            .focusProperties {
                                onExit = {
                                    val canSave = mainFocusRequester.saveFocusedChild()

                                }
                                onEnter = {
                                    val canRestore = mainFocusRequester.restoreFocusedChild()
                                     if (!canRestore) {
                                        firstItemFocusRequester.requestFocus()
                                        //verticalListFocusRequesters.getOrNull(1)?.requestFocus()
                                    }
                                }
                            }
                            .wrapContentHeight()
                            .fillMaxWidth(),//.wrapContentHeight(),
                        contentPadding = PaddingValues( horizontal = 48.dp, vertical = 4.dp),

                        title = stringResource(Res.string.may_like),
                        actionTitle = null, onActionClick = { }) {
                        itemsIndexed (items) { index,stream ->
                            NetworkImageCard(
                                modifier = Modifier.then(
                                    if (index == 0)
                                        Modifier.focusRequester(firstItemFocusRequester)
                                    else Modifier
                                ),

                                src = stream.streamIcon,
                                title = stream.name ?: "",
                                description = stream.formattedRating() ?: "",
                                onClick = {
                                    rootNavViewModel.navigate(Screen.MovieDetail(stream.streamId))
                                }
                            )
                        }




                    }
                }



            }

        }

    )


    val updatedId by rememberUpdatedState(id)

    LaunchedEffect(updatedId) {
        if(streamState ==null) {
             val stream = id?.let { vodStreamsViewModel.getVodByStreamId(it) }


            // Load stream info
            stream?.streamId?.let { streamId ->
                vodInfoViewModel.loadInfo(streamId) {stream->
                    trailerUrl = stream?.info?.youtubeTrailer
                    scope.launch {
                        vodInfoViewModel.getTMDBLogo(stream?.info?.tmdb_id,
                            onFinished = {
                                streamTitleLogo=it
                            },
                            onError = {

                            })
                    }
                    // optional callback logic
                }
            }

        }

        // Collect favorite state

    }


}
